import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getCourses } from 'actions/courses';
import { getSections } from 'actions/sections';
import { CardsContainer } from 'components/Cards/Card';
import Course from 'components/Presentation/Cards/Course';
import CourseForm from 'containers/Forms/CourseForm';
import Modal from 'containers/Modals/Modal';
import React, { Component } from 'react';
import { getRootUrl } from 'helpers/url';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setPageTitle, setPageActions } from 'actions/header';
import LoadingCards from 'components/Cards/LoadingCard';
import User from '_class/User';

var Courses = /*#__PURE__*/function (_Component) {
  _inherits(Courses, _Component);

  var _super = _createSuper(Courses);

  function Courses(props) {
    var _this;

    _classCallCheck(this, Courses);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      var user = new User(_this.props.currentUser);

      if (!(user.isCourseAdministrator() || user.isAdministrator())) {
        _this.props.history.push(getRootUrl());
      }

      var actions = [];

      _this.props.setPageTitle(_this.props.translate('nav_courses'));

      actions.push({
        type: 'button',
        value: _this.props.translate('Create'),
        onClick: _this.openModal,
        icon: 'plus'
      });

      _this.props.setPageActions(actions);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var user = new User(_this.props.currentUser);

      if (user.isCourseAdministrator() || user.isAdministrator()) {
        _this.setState({
          isLoading: true
        });

        _this.props.getCourses("CUSTOM_COURSE").then(function () {
          _this.setState({
            isLoading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (reload, skipPrompt) {
      if (skipPrompt) {
        _this.setState({
          modalIsOpen: false
        });
      } else {
        _this.setState({
          modalIsOpen: false
        });
      }
    });

    _this.state = {
      modalIsOpen: false,
      isLoading: false
    };
    return _this;
  }

  _createClass(Courses, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "my_groups"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modalIsOpen,
        onClose: this.closeModal,
        title: this.props.translate('create-course')
      }, /*#__PURE__*/React.createElement(CourseForm, {
        onClose: this.closeModal,
        editView: false
      })), this.state.isLoading ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 3
      }) : /*#__PURE__*/React.createElement(CardsContainer, {
        key: "myCourses-1"
      }, this.props.courses.map(function (course) {
        return /*#__PURE__*/React.createElement(Course, {
          key: course.id,
          course: course
        });
      })));
    }
  }]);

  return Courses;
}(Component);

function mapStateToProps(state) {
  return {
    courses: state.Courses.courses,
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser
  };
}

export default withRouter(connect(mapStateToProps, {
  getSections: getSections,
  getCourses: getCourses,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions
})(Courses));